"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FeatureCardsList_1 = require("components/FeatureCardsList");
var FeatureCard_1 = require("components/FeatureCard");
var CongridConfigurationModal_1 = require("components/modals/CongridConfigurationModal");
var SokositeConfigurationModal_1 = require("components/modals/SokositeConfigurationModal");
var configurationModalActions = require("@caddigital/sok-reducers/lib/actions/congrid/configModal");
var sokositeConfigurationModalActions = require("@caddigital/sok-reducers/lib/actions/sokosite/configModal");
var Types = require("types");
var Modelspace_1 = require("../Modal/Modelspace");
var Subproject_1 = require("../Modal/Subproject");
var Row = sok_ui_1.Grid.Row, Column = sok_ui_1.Grid.Column;
var mapStateToProps = function (state) {
    return {
        configModal: state.congrid.configModal,
        sokositeConfigModal: state.sokosite.configModal
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    openCongridConfigurationModal: function () {
        return dispatch(configurationModalActions.toggleModal());
    },
    openSokositeConfigurationModal: function () {
        return dispatch(sokositeConfigurationModalActions.toggleModal());
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('modelspaceIsOpen', 'setModelspaceIsOpen', false), (0, recompose_1.withState)('subprojectIsOpen', 'setSubprojectIsOpen', false), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'step1-enterprise-features' },
    React.createElement("div", { className: 'card-box' },
        React.createElement(Row, null,
            React.createElement(Column, { medium: 12 },
                React.createElement("h2", null,
                    React.createElement(Icon_1.Icon, { className: 'icofont-tools-alt-2' }),
                    ' ',
                    (0, translation_1.getLocalization)('admin/projectsTab/editProject/EnterpriseFeaturesPrices')),
                React.createElement("div", { className: "card-box-content" },
                    props.errors && props.errors['features'] && (React.createElement("div", { className: 'feature-validation-errors' }, props.errors['features'].map(function (x) { return (React.createElement("div", null, x)); }))),
                    props.wizard.step1.id === -1 &&
                        props.wizard.step1.featuresStatus === 'STANDBY' &&
                        props.customerFeaturesStatus === 'STANDBY' && (React.createElement("div", { className: 'please-select-customer' },
                        React.createElement("div", null,
                            React.createElement("img", { src: '/assets/sokopro_mario_icon.svg' })),
                        React.createElement("div", null,
                            React.createElement("b", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/templates/dearAdmin'))),
                        React.createElement("div", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/pleaseSelectCustomer')))),
                    !(props.wizard.step1.id === -1 &&
                        props.wizard.step1.featuresStatus === 'STANDBY' &&
                        props.customerFeaturesStatus === 'STANDBY') && (React.createElement(FeatureCardsList_1.FeatureCardsListContainer, { allFeatures: props.customerFeatures, allFeaturesStatus: props.customerFeaturesStatus, features: props.wizard.step1.features, featuresStatus: props.wizard.step1.featuresStatus }, function (feature) {
                        var toggleSettings;
                        if (feature.constant === 'CONGRID') {
                            toggleSettings = props.openCongridConfigurationModal;
                        }
                        else if (feature.constant === 'SOKOSITE') {
                            toggleSettings = props.openSokositeConfigurationModal;
                        }
                        else if (feature.constant === 'MODELSPACE') {
                            toggleSettings = props.setModelspaceIsOpen;
                        }
                        else if (feature.constant === 'SUBPROJECT') {
                            toggleSettings = props.setSubprojectIsOpen;
                        }
                        return (React.createElement(FeatureCard_1.default, { type: 'PROJECT', key: feature.uuid, feature: feature, select: props.select, unselect: props.unselect, updatePrice: props.updatePrice, toggleSettings: toggleSettings, settingsDisabled: props.wizard.step1.id === -1 }));
                    })),
                    React.createElement(CongridConfigurationModal_1.default, { projectId: props.wizard.step1.id }),
                    React.createElement(SokositeConfigurationModal_1.default, { projectId: props.wizard.step1.id }),
                    props.wizard.step1.customer && (React.createElement(Modelspace_1.default, { customer: props.wizard.step1.customer, isOpen: props.modelspaceIsOpen, toggleModal: props.setModelspaceIsOpen })),
                    React.createElement(Subproject_1.default, { projectId: props.wizard.step1.id, isOpen: props.subprojectIsOpen, toggleModal: props.setSubprojectIsOpen }))))))); });
